// extracted by mini-css-extract-plugin
export default {"nav_box":"index_nav_box_wYwna","nav":"index_nav_SV8MS","nav_piaohong":"index_nav_piaohong_ANCef"};